"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TabsContext = _interopRequireDefault(require("./TabsContext"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Tab = (0, _react.forwardRef)((props, ref) => {
  const {
    prefix,
    ssrIcon,
    disabled,
    className,
    children,
    text,
    tabPanelId,
    active,
    previousTab,
    nextTab,
    onClick,
    onKeyDown,
    ...otherProps
  } = props;
  const ctx = (0, _react.useContext)(_TabsContext.default);
  return _react.default.createElement("button", _extends({
    disabled: disabled,
    ref: ref
  }, otherProps, {
    className: (0, _classnames.default)(`${prefix}tabs__tab`, className, ctx.activeTab === tabPanelId && `${prefix}tabs__tab--active`),
    onClick: e => {
      const prevent = onClick && onClick(e);
      if (!prevent) (0, _utils.onTabClick)(e, ctx.setActiveTab, tabPanelId);
    },
    onKeyDown: e => {
      const prevent = onKeyDown && onKeyDown(e);
      if (!prevent) (0, _utils.onTabKeyDown)(e, tabPanelId, ctx.setActiveTab, ctx.tabs, ctx.root);
    },
    role: "tab",
    "aria-selected": ctx.activeTab === tabPanelId,
    "aria-controls": tabPanelId,
    tabIndex: !disabled && ctx.activeTab === tabPanelId ? null : -1
  }), ssrIcon && _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: ssrIcon
  }), text, children);
});
Tab.defaultProps = {
  prefix: ''
};
var _default = Tab;
exports.default = _default;